import 'twin.macro';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function Thead(props: Props) {
  const { children, className } = props;
  return (
    <thead tw="bg-neutral-white" className={className}>
      {children}
    </thead>
  );
}
